import { motion } from "framer-motion";
import { Stack, Switch } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { showNotification } from "../../store/slices/notificationSlice";
import { updateTelegramNotificationToggle } from "../../store/slices/userSlice";
import { HubError } from "../../class/Error";
import Header from "../../_modules/Header/Header";
import PageLayout from "../../_components/PageLayout";
import { useState } from "react";
import { useApi } from "../../_hooks/use-api";
import { getTelegramNotificationValue } from "./utils";
import { ANIM_PROFILE_DURATION, slideAnimationReverse } from "../../_app/animation-consts";
import { useTranslation } from "react-i18next";
import Text from "../../_components/Text";

const NotificationSettingsPage = () => {
  const user = useSelector((state: RootState) => state.user);
  const { t } = useTranslation("profile");

  const [enabled, setEnabled] = useState<boolean>(
    getTelegramNotificationValue(user.profile.settings)
  );
  const dispatch = useDispatch();
  const api = useApi();

  const switchTelegramNotificationToggle = async (value: boolean) => {
    let telegramNotificationToggle: any = [
      { name: "TELEGRAM_NOTIFICATION_ENABLED", value: value ? "true" : "false", format: "TOGGLE" },
    ];
    try {
      await api.updateUserSettings(user.profile.profileId, telegramNotificationToggle);
      dispatch(
        showNotification({
          message: `Telegram notifications are ${value ? "enabled" : "disabled"}`,
          severity: "info",
        })
      );

      dispatch(updateTelegramNotificationToggle(value ? "true" : "false"));
      setEnabled(value);
    } catch (error: any) {
      error instanceof HubError
        ? dispatch(
            showNotification({
              message: `${error.message} ${error.detailedMessage}`,
              severity: "error",
            })
          )
        : dispatch(showNotification({ message: error.message, severity: "error" }));
    }
  };

  return (
    <PageLayout
      header={<Header pageTitle={t("notifications")} needBack />}
      contentSx={{ padding: "20px 8px 0" }}
    >
      <motion.div
        layout
        initial="in"
        animate="animate"
        exit="out"
        variants={slideAnimationReverse}
        transition={{ duration: ANIM_PROFILE_DURATION }}
      >
        <Stack direction={"column"} alignItems={"center"} spacing={1} sx={{ width: "100%" }}>
          <Stack
            sx={{ width: "100%" }}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            spacing={1}
          >
            <Text variant="s">{t("enableNotifications")}</Text>
            <Switch checked={enabled} onChange={() => switchTelegramNotificationToggle(!enabled)} />
          </Stack>
        </Stack>
      </motion.div>
    </PageLayout>
  );
};

export default NotificationSettingsPage;
